import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBrandStrong,
  colorLandingInk,
  colorLandingLine,
  colorLandingMuted,
  colorLandingSurface,
  colorLandingText,
} from "src/design/tokens";

// Decorative QR modules: three finder patterns plus a scatter of data cells.
const FINDERS = [
  { x: 2, y: 2 },
  { x: 58, y: 2 },
  { x: 2, y: 58 },
];
const DATA_CELLS = [
  [28, 4], [36, 4], [44, 8], [28, 12], [40, 16], [48, 20],
  [28, 28], [36, 28], [44, 28], [52, 28], [60, 28], [68, 28],
  [4, 28], [12, 36], [4, 44],
  [28, 36], [40, 40], [52, 44], [64, 40], [72, 48],
  [28, 52], [36, 60], [44, 56], [52, 64], [60, 60], [68, 68],
  [28, 68], [44, 72], [56, 72],
];

/** QR code beside three priced menu lines, for the menu tab. */
export const MenuMedia = () => {
  const { t } = useTranslation();

  const dishes = [
    { nameKey: "landingPage.showcase.menu.dishes.salad", price: "90 MAD" },
    { nameKey: "landingPage.showcase.menu.dishes.tajine", price: "120 MAD" },
    { nameKey: "landingPage.showcase.menu.dishes.dessert", price: "80 MAD" },
  ];

  return (
    <Box sx={{ display: "flex", gap: 2.25, alignItems: "center", width: "100%" }}>
      <Box
        aria-hidden="true"
        sx={{
          width: 96,
          height: 96,
          flexShrink: 0,
          borderRadius: "10px",
          backgroundColor: colorLandingSurface,
          border: `1px solid ${colorLandingLine}`,
          p: 1,
        }}
      >
        <Box component="svg" viewBox="0 0 80 80" sx={{ width: "100%", height: "100%" }}>
          {FINDERS.map((finder) => (
            <g key={`${finder.x}-${finder.y}`}>
              <rect
                x={finder.x}
                y={finder.y}
                width={20}
                height={20}
                fill={colorLandingInk}
              />
              <rect
                x={finder.x + 3}
                y={finder.y + 3}
                width={14}
                height={14}
                fill={colorLandingSurface}
              />
              <rect
                x={finder.x + 6}
                y={finder.y + 6}
                width={8}
                height={8}
                fill={colorLandingInk}
              />
            </g>
          ))}
          {DATA_CELLS.map(([x, y]) => (
            <rect key={`${x}-${y}`} x={x} y={y} width={4} height={4} fill={colorLandingInk} />
          ))}
        </Box>
      </Box>

      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.375 }}>
        {dishes.map((dish) => (
          <Box
            key={dish.nameKey}
            sx={{ display: "flex", alignItems: "baseline", fontSize: 12.5 }}
          >
            <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: colorLandingText }}>
              {t(dish.nameKey)}
            </Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: `1px dotted ${colorLandingMuted}`,
                opacity: 0.5,
                mx: 1,
              }}
            />
            <Typography
              sx={{ fontSize: 12.5, color: colorLandingBrandStrong, fontWeight: 700 }}
            >
              {dish.price}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
